import { fromFetch } from 'rxjs/fetch';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { withJwt } from '../../utils/with-jwt';
import { accountsEnvironment } from './accounts-environment';
import { companyOrdersSchema } from './schemas/company-order.schema';

export function getCompanyOrders() {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(accountsEnvironment.companyOrdersUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(companyOrdersSchema));
}
